import * as React from 'react';
import { ITurnInfoSchema } from '../../repositories/newbuilding-card/entities/house/TurnInfoSchema';
import * as style from './BasicInfo.css';
import { Layout } from '../Layout';
import { Basic, Address } from './parts';
import { Specifications } from '../Specifications';
import { IBasicProps } from './parts/Basic/Basic';
import { IAddressProps } from './parts/Address/Address';
import { ISpecificationItem } from '../../types/newbuilding/specification';

export interface IBasicInfoProps {
  basic: IBasicProps;
  address: IAddressProps;
  specifications: ISpecificationItem[];
  housesByTurnDisplay: ITurnInfoSchema[];
  housesCount: number;
}

export function BasicInfo({ basic, address, specifications, housesByTurnDisplay, housesCount }: IBasicInfoProps) {
  return (
    <div className={style['basicInfo']}>
      <Layout fullwidth dataMark={'BasicInfo'}>
        <Basic {...basic} />
        <Address {...address} />
        <Specifications
          specifications={specifications}
          housesByTurnDisplay={housesByTurnDisplay}
          housesCount={housesCount}
        />
      </Layout>
    </div>
  );
}
